import { render, staticRenderFns } from "./OrgFilialsContainer.vue?vue&type=template&id=53acb79d&scoped=true"
import script from "./OrgFilialsContainer.vue?vue&type=script&lang=js"
export * from "./OrgFilialsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53acb79d",
  null
  
)

export default component.exports